// extracted by mini-css-extract-plugin
export var fullWidthButton = "_pc-0";